var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"enterprise-agency-view-data"}},[_c('enterprise-agency-form',{attrs:{"mode":"view","itemId":_vm.itemId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }